import Main from '../../Home/Main'
import LeftSide from '../Common/LeftSide'
import { LayoutThree } from '../../Layout/CommonStyle'
import { setMenuIndex } from '../../../store/userSlice'
import { useAppDispatch } from '../../../store'
import { MenteeMenu } from '../../../models/Enums'
import RecentJobs from '../../Common/RecentJobs'
import { useEffect } from 'react'
import TestList from '../../Common/TestList'

function MenteeMain() {
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(setMenuIndex(MenteeMenu.HOME))
  }, [])

  return (
    <LayoutThree>
      <Main />
      <TestList />
      <RecentJobs />
    </LayoutThree>
  )
}

export default MenteeMain
